import { translations } from 'locales/i18n';
import { useTranslation } from 'react-i18next';
import { Grid, Paper } from '@mui/material';

import './styles/NoOffer.scss';

export default function NoOffer() {
  const { t } = useTranslation();
  return (
    <Grid container className="no-offer" component={Paper}>
      {t(translations.pages.companyDetailPage.noOffers())}
    </Grid>
  );
}
